<template>
  <div class="contact-change-company">
    <modal
      title=""
      :open="isOpen"
      saveText="Confirm"
      @save="save()"
      @cancel="cancel()"
    >
      <auto-complete
        model="organization-companies"
        label="Select Company"
        placeholder="Search..."
        name="value"
        :item="item"
        @change="updateVal"
        :autofocus="true"
        :acMinCharacters="3"
      ></auto-complete>

      <modal
        :open="confirmUpdateOpen"
        :title="$t('ui.contacts.modals.update.title')"
        type="warning"
        :showCancelForWarning="true"
        :saveText="$t('ui.global.save')"
        @save="update"
        @cancel="cancel"
      >
        <p>
          {{
          $t("ui.global.update_conformation", {
              name: $tc("ui.contacts.enumeration", selected, { n: selected })
            })
          }}
        </p>
      </modal>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/helpers/Layout/NewModal.vue";
import AutoComplete from "@/components/helpers/DataDisplay/AutoComplete";

export default {
  components: { AutoComplete, Modal },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    idCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      item: {},
      selected: 0,
      confirmUpdateOpen: false,
    };
  },
  beforeMount() {
    this.init();
  },
  watch: {
    isOpen: function () {
      return this.init();
    },
    idCount: function () {
      return this.init();
    },
  },
  computed: {
    warningSrc() {
      return require("@/assets/warning-message.svg");
    },
  },
  methods: {
    init() {
      this.item = {
        id: null,
        value: "",
      };
      this.selected = this.idCount;
    },
    updateVal(payload) {
      this.item = payload;
      this.item.value = payload.name;
    },
    save() {
      if (this.item && this.item.id) {
        this.confirmUpdateOpen = true;
      }
    },
    update() {
      if (this.item && this.item.id) {
        this.$emit("save", this.item.id);
        this.confirmUpdateOpen = false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="sass">
@media (max-width: 575px)
  .contact-change-company
    max-height: 500px !important
    .modal-wrapper
      min-width: 100%
      width: 320px
    .modal-component
      padding: 1em 0 !important
      text-align: center !important

.contact-change-company
  .modal-component
    max-height: 600px
    overflow: visible
  field
    display: block
  .field-radio
    width: 50%
  .flex
    padding-right: 5px
  .autocomplete-results
    max-height: 240px
</style>



// WEBPACK FOOTER //
// ChangeCompany.vue?51a28b06